export default () => ({
  tools: [],
  shopDevices: [],
  criteriaChanged: false
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/state.js